module.exports = __webpack_public_path__ + "media/img/apple-icon-180x180-9393acfe5cc70465f3456c27781d130e.png";